import produce from 'immer';

import { ADD_AN_ADD_ON_DEAL_PRODUCT_START } from '@redux/actions/buyingOptions/buyingOptionsTypes';

const initState = {
  addOnDealProducts: []
};

const BOAddOnDealReducer = (state = initState, action) => produce(state, draft => {
  switch (action.type) {
  case ADD_AN_ADD_ON_DEAL_PRODUCT_START:
    draft.addOnDealProducts = [...action.payload];
    break;
  }

  return draft;
});

export default BOAddOnDealReducer;